// extracted by mini-css-extract-plugin
module.exports = {"container":"BigNavButtons__container","bigNavButton":"BigNavButtons__bigNavButton","image":"BigNavButtons__image"};